import React from 'react'

const Skills = () => {
    return (
        <div className="h-full w-full flex flex-col justify-center px-10 md:px-0 items-center">
            <h1 className="text-center text-2xl font-bold mb-8">Skills</h1>
            <div className="w-full md:w-4/5 lg:w-2/3 shadow-2xl rounded-lg flex flex-col items-center p-4">
                <div className="w-2/3 mb-2">
                    <h3>Nodejs</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-3/4 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>Javascript</h3>
                    <div className="w-ful h-2 bg-slate-300 rounded-lg">
                        <div className="w-5/6 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>React</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-4/5 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>Nextjs</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-2/4 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>Tailwindcss</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-5/6 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>MongoDB</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-4/5 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>SQL</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-4/6 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>Typescript</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-2/4 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>Technical writing</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-5/6 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>Markdown</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-5/6 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>Mobile development</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-3/4 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>React Native</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-3/4 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
                <div className="w-2/3 mb-2">
                    <h3>Redux</h3>
                    <div className="w-full h-2 bg-slate-300 rounded-lg">
                        <div className="w-5/6 bg-orange-500 h-full rounded-lg"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skills
